import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(2),
    },
  },
  buttonContainer: {
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(2),
    },
  },
  button: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}))

export default styles
